import React from "react";

// Post-login destination based on the user's role/attraction state.
export function postLoginPath(u) {
  if (u?.is_super_admin) return "/super-admin";
  if (!u?.attraction_id) return "/onboarding";
  return "/dashboard/overview";
}

// Emergent-managed Google OAuth — redirects to the hosted auth screen.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleButton({ label = "Continue with Google" }) {
  const go = () => {
    const redirectUrl = window.location.origin + "/dashboard/overview";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button onClick={go} data-testid="google-login"
            className="w-full justify-center inline-flex items-center gap-2.5 bg-white text-[#1f1f1f] font-medium rounded-[8px] py-2.5 hover:bg-[#f2f2f2] transition-colors">
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
        <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.48h4.84c-.21 1.13-.84 2.08-1.79 2.72v2.26h2.9c1.7-1.56 2.69-3.86 2.69-6.62z"/>
        <path fill="#34A853" d="M9 18c2.43 0 4.46-.8 5.95-2.18l-2.9-2.26c-.8.54-1.83.86-3.05.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.32A9 9 0 0 0 9 18z"/>
        <path fill="#FBBC05" d="M3.97 10.72A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.18.29-1.72V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.04l3.01-2.32z"/>
        <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.34l2.58-2.58A8.99 8.99 0 0 0 9 0 9 9 0 0 0 .96 4.96l3.01 2.32C4.68 5.16 6.66 3.58 9 3.58z"/>
      </svg>
      {label}
    </button>
  );
}

// Password strength: returns {score 0-4, label, valid (meets policy)}.
export function passwordStrength(p) {
  const hasLen = p.length >= 8, hasUpper = /[A-Z]/.test(p), hasNum = /\d/.test(p), hasSym = /[^A-Za-z0-9]/.test(p);
  const score = [hasLen, hasUpper, hasNum, hasSym].filter(Boolean).length;
  const label = ["Too weak", "Weak", "Fair", "Good", "Strong"][score];
  return { score, label, valid: hasLen && hasUpper && hasNum };
}

export function PasswordStrengthBar({ value }) {
  const { score, label, valid } = passwordStrength(value || "");
  const colors = ["#3a3a3a", "#dc2626", "#f59e0b", "#eab308", "#22c55e"];
  return (
    <div className="mt-1.5" data-testid="password-strength">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-1 flex-1 rounded-full" style={{ background: i < score ? colors[score] : "#222" }} />
        ))}
      </div>
      {value && <div className="text-[11px] mt-1" style={{ color: valid ? "#86efac" : "#8a8a8a" }} data-testid="password-strength-label">{label} · min 8 chars, 1 uppercase, 1 number</div>}
    </div>
  );
}
